import { motion } from 'framer-motion';
import { arrow3 } from 'utils';
import { useAppContext } from 'contexts/AppContext';
import Close from '@/components/elements/Close/Close';
import LineLoader from '@/components/elements/LineLoader/LineLoader';
import styles from './PillsNavigation.module.scss'

const PillsNavigation = ({loading, onBack, onClose, currentStep, hidePills, hideBackBtn, fixed=false}) => {
    const { appLoading } = useAppContext();
    return (
        <div className={styles.pillsNavigation} style={fixed ? {position: "fixed"}:{}}>
            {!hideBackBtn ? 
            <motion.div className={styles.back} initial={{opacity: 0, scale: .5}} animate={{opacity: 1, scale: [1, 1.1, 1], transition: {duration: .35}}} onClick={onBack} whileTap={{scale: .8}}>{arrow3("white", "left")}</motion.div>
            :
            <div />
            }
            {!hidePills ?
            <div className={styles.steps}>
                {[1,2,3].map((step)=>
                    <div className={`${styles.step} ${step <= currentStep ? styles['step-active'] : ''}`} key={step}></div>
                    )}
            </div>
            :
            <div />
            }
            <div></div>
            {(loading || appLoading) &&
                <LineLoader /> 
            }
        </div>
    )
}

export default PillsNavigation